import { render, staticRenderFns } from "./AirTicketChoose.vue?vue&type=template&id=1f0b1629&scoped=true"
import script from "../../assets/ts/tripinfo/AirTicketChoose.ts?vue&type=script&lang=ts&external"
export * from "../../assets/ts/tripinfo/AirTicketChoose.ts?vue&type=script&lang=ts&external"
import style0 from "./AirTicketChoose.vue?vue&type=style&index=0&id=1f0b1629&prod&lang=sass&scoped=true"
import style1 from "./AirTicketChoose.vue?vue&type=style&index=1&id=1f0b1629&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0b1629",
  null
  
)

export default component.exports